import { RouterEffects } from './router.effects';
import { HomeUIEffects } from './home-ui.effects';
import { ErrorEffects } from './error.effects';

export const effects = [RouterEffects, HomeUIEffects, ErrorEffects];

export * from './router.effects';
export * from './error.effects';
